import $ from 'jquery';
import Cookies from 'js-cookie';
import 'magnific-popup';
import '../Language/magnific-popup';

(function () {
    const cookieName = 'content_popup';
    let $popup = $('#content-popup');

    if ($popup.length === 0 || Cookies.get(cookieName)) {
        return;
    }

    $.magnificPopup.open({
        items: {
            src: '#content-popup'
        },
        type: 'inline',
        callbacks: {
            open: function () {
                Cookies.set(cookieName, '1', { expires: 1});
            }
        }
    });
})();
